import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../context/AudioContext';
import { fetchArtists } from '../services/api';
import { Link } from 'react-router-dom';

const Artists = () => {
    const { setCurrentChannel } = useContext(AudioContext);
    const [latestChannels, setLatestChannels] = useState([]);
    const [history, setHistory] = useState([]);

    useEffect(() => {
        const loadLatestChannels = async () => {
            try {
                const data = await fetchArtists(); // Use the API function
                setLatestChannels(data);
            } catch (error) {
                console.error('Error loading latest channels:', error);
            }
        };

        loadLatestChannels();
    }, []);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length) updatedHistory.pop();

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    return (
        <main className="main">
            <div className="container-fluid">
                

                {/* Title */}
                <div className="row row--grid">
                    <div className="col-12">
                        <div className="main__title main__title--page">
                            <h1>Available Artists</h1>
                        </div>
                    </div>
                </div>

                {/* Artist List */}
                <div className="row row--grid">
                    {latestChannels.map((channel) => (
                        <div className="col-3 col-sm-4 col-lg-1">
                            <div className="album">
                                <div className="album__cover" key={channel.id} onClick={() => setCurrentChannel(channel)}>
                                    <img src={channel.favicon} alt={channel.name} />
                                    <Link role='button' onClick={() => playChannel(channel)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                            <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                        </svg>
                                    </Link>
                                </div>
                                <div className="album__title">
                                    <h3><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                    <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Artists;
